var scope_0 = require('/home/amanda/repos/dragonchain.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/72977bb2dcb0f54377f6ffd9b0724721.js').default;
var scope_1 = require('/home/amanda/repos/dragonchain.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    